import { render } from "./apoioComponent.vue?vue&type=template&id=02f9317c"
import script from "./apoioComponent.vue?vue&type=script&lang=js"
export * from "./apoioComponent.vue?vue&type=script&lang=js"

import "./apoioComponent.vue?vue&type=style&index=0&id=02f9317c&lang=css"

import exportComponent from "D:\\ProjetosCodes\\Ideias\\front\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__